import { useQuery } from 'react-query'
import { useSvcCompareVersionsContext } from '@dc-shared-web/providers'
import type {
  ComparisonDataResponse,
  FetchComparisonDataParams,
} from '@dc-shared-web/hooks/api/comparison/types'
import { fetchComparisonData } from '@dc-shared-web/hooks/api/comparison/fetchComparisonData'
import { COMPARISON_DATA_QUERY_KEY } from '@dc-shared-web/hooks/api/queryKeys'

export const useFetchComparisonData = (params: FetchComparisonDataParams) => {
  const svcCompareVersionApiClient = useSvcCompareVersionsContext()

  return useQuery<ComparisonDataResponse>({
    queryKey: [
      COMPARISON_DATA_QUERY_KEY,
      params.version_a_guid,
      params.version_b_guid,
      params.page,
      params.limit,
    ],
    queryFn: () =>
      fetchComparisonData(svcCompareVersionApiClient, {
        version_a_guid: params.version_a_guid,
        version_b_guid: params.version_b_guid,
        page: params.page ? params.page?.toString() : undefined,
        limit: params.limit ? params.limit?.toString() : undefined,
      }),
    enabled: !!params.version_a_guid && !!params.version_b_guid,
  })
}
